module.exports = __webpack_public_path__ + "img/fraude.a4185519.webp";